import BlockingForm from "collections/Form/BlockingForm";
import { Section } from "collections/Section";
import { SubmitButton } from "elements";
import { Field, FieldProps, Form, Formik } from "formik";
import { Redirect, Route, Switch } from "polyrouter";
import React from "react";
import { useTranslation } from "utilities/i18n";
import { Layout } from "views/Main/Layouts";
import { ErrorDisplay } from "../../../Inventory/Settings-Shared/DeviceSettingsComponents";
import { deviceSettingsSchema } from "../../../Inventory/Settings/schemas/deviceSettingsSchema";
import { AppSoftwareUpdateSettings } from "./AppSoftwareUpdateSettings";
import { DeviceAlertsSettings } from "./DeviceAlertsSettings";

// THE CODE BELOW HAS BEEN HARD CODED DUE TO THE BACKEND NOT BEING READY YET.
// IT WILL BE FEATURE FLAGGED AND NOT HAVE ANY IMPACT ON PRODUCTION
// TODO: When enabled, refactor / visit related SCSS and clean up

export const DeviceUserSettings: React.FC<{ id: string }> = ({ id }) => {
  const { Content } = Layout;
  const { Header } = Section;
  const { t } = useTranslation();
  return (
    <Content scrolling>
      <Formik
        name="DeviceSettings"
        initialValues={{ name: "" }}
        validationSchema={deviceSettingsSchema}
        enableReinitialize={true}
        // validate={values => validate(values, {name: ''})}
        onSubmit={() => {}}
      >
        {({ dirty }) => (
          <BlockingForm unsavedChanges={dirty} allowedSubRoutes={["/settings"]}>
            <Form className="form pb-2">
              <div className="header-section">
                <div className="header-information grid">
                  <Header className="col-6 col-xl-8 d-flex">
                    Cody Boaz
                    <div className="page-subheader">&nbsp; | US Remote</div>
                  </Header>
                  <div
                    className="col-6 col-xl-4 text-right"
                    data-testid="save-settings-buttons"
                  >
                    <Field name="reset">
                      {({
                        form: { dirty, handleReset, isSubmitting }
                      }: FieldProps) => {
                        return (
                          <button
                            type="button"
                            className="btn"
                            disabled={isSubmitting || !dirty}
                            onClick={handleReset}
                          >
                            {t("DISCARD")}
                          </button>
                        );
                      }}
                    </Field>
                    <Field name="submit">
                      {({
                        form: { dirty, isSubmitting, isValid }
                      }: FieldProps) => (
                        <SubmitButton
                          isSubmitting={isSubmitting}
                          disabled={!dirty || !isValid}
                        />
                      )}
                    </Field>
                  </div>
                </div>
                <ErrorDisplay />
              </div>

              <Content.ScrollingList>
                <Switch>
                  <Route nest path="/device-alerts">
                    <DeviceAlertsSettings id={id} />
                  </Route>
                  <Route nest path="/software-update">
                    <AppSoftwareUpdateSettings id={id} />
                  </Route>
                  <Route nest path="/">
                    <Redirect
                      nest
                      to={{
                        pathname: "device-alerts",
                        search: `user_id=${id}`
                      }}
                    />
                  </Route>
                </Switch>
              </Content.ScrollingList>
            </Form>
          </BlockingForm>
        )}
      </Formik>
    </Content>
  );
};
